import * as TooltipPrimitive from "@radix-ui/react-tooltip"
import { cn } from "@/lib/utils"
import type { ReactNode } from "react"

interface TooltipProps {
  content: ReactNode
  children: ReactNode
  side?: "top" | "right" | "bottom" | "left"
  align?: "start" | "center" | "end"
  delayDuration?: number
  className?: string
}

export function Tooltip({
  content,
  children,
  side = "bottom",
  align = "center",
  delayDuration = 400,
  className,
}: TooltipProps) {
  if (!content) return <>{children}</>

  return (
    <TooltipPrimitive.Root delayDuration={delayDuration}>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side={side}
          align={align}
          sideOffset={6}
          className={cn(
            "z-[100] max-w-[240px] rounded-lg border border-zinc-700/80 bg-zinc-800 px-2.5 py-1.5 text-xs text-zinc-200 shadow-xl shadow-black/30",
            "animate-[tooltip-in_0.15s_ease-out]",
            className,
          )}
        >
          {content}
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  )
}

export const TooltipProvider = TooltipPrimitive.Provider

// Standard shadcn-compatible low-level exports used by ai-elements
export const TooltipTrigger = TooltipPrimitive.Trigger
export const TooltipContent = TooltipPrimitive.Content
